import { isNull } from "App/utils/helpers";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAccessDeleteSEP, getAccessUpdateSEP } from "redux/actions/Access";
import {
    getAccessFA,
  getAsuransi,
  getDokter,
  getGudangPenjualan,
  getJenisLayanan,
  getKelasKamar,
  getKelasKunjungan,
  getPerusahaan,
  getPoliklinik,
  getRuang,
  getSpesialis,
  getSettingRS,
} from "redux/actions/Master";
import { getSettingSIMRS } from "redux/actions/Setting";

function PageInit({ children }) {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAsuransi());
    dispatch(getPerusahaan());
    dispatch(getJenisLayanan());
    dispatch(getDokter());
    dispatch(getPoliklinik());
    dispatch(getSpesialis());
    dispatch(getSettingSIMRS());
    dispatch(getKelasKunjungan());
    dispatch(getKelasKamar());
    dispatch(getGudangPenjualan());
    dispatch(getAccessUpdateSEP());
    dispatch(getAccessDeleteSEP());
    dispatch(getRuang());
    dispatch(getAccessFA());
    dispatch(getSettingRS());
  }, [dispatch]);
  const master = useSelector(({ master }) => master);
  const favIcon = master.setting.favicon;
  useEffect(() => {
    document.title = process.env.REACT_APP_NAMA_RUMAH_SAKIT;
    const link = document.querySelector("link[rel~='icon']");
    if(!isNull(favIcon)){
      link.href = favIcon;
    }
  }, [favIcon]); // eslint-disable-line react-hooks/exhaustive-deps

  return <>{children}</>;
}

export default PageInit;
